import { Grid } from '@mui/material'

import { getMetricsPositionStorageKey } from '@common/components/MetricsSelector/utils'
import { useLocalStorage } from '@common/utils'
import { getDefaultMetricsPositions } from '@common/utils/metricsUtils'
import metrics from '@rest/pages/SmokeMetrics/metrics'

import { METRICS_DISPLAY_GRAPH } from './components/DisplaySelector'
import MetricCard from './MetricCard'

/**
 * @component
 * @param {Object} props - The props for the component.
 * @param {Object} props.smokeMetrics
 * @param {Object} props.selectedMetrics
 * @param {string} props.selectedView
 * @param {Object} props.selectedInterval
 * @param {number} props.selectedInterval.value
 * @param {string} props.selectedInterval.type
 * @param {Object[]} props.dateRangeValue
 * @param {boolean} props.showTotal
 * @param {boolean} [props.showPercentageChange]
 */
export default function GroupedByMetricView({
  smokeMetrics,
  selectedMetrics,
  selectedView,
  selectedInterval,
  dateRangeValue,
  showTotal,
  showPercentageChange = false,
}) {
  const [metricsPositions] = useLocalStorage(
    getMetricsPositionStorageKey(),
    getDefaultMetricsPositions(metrics),
  )

  return Object.keys(smokeMetrics)
    .sort((a, b) => {
      const aPosition = metricsPositions[a] ?? 99
      const bPosition = metricsPositions[b] ?? 99
      return aPosition > bPosition ? 1 : -1
    })
    .filter((key) => selectedMetrics[key])
    .map((key) => {
      const data = smokeMetrics[key]

      const size =
        selectedView === METRICS_DISPLAY_GRAPH ? { xll: 4, sm: 6 } : { xll: 6, sm: 12 }

      return (
        <Grid key={key} size={size} width="inherit">
          <MetricCard
            metric={key}
            selectedView={selectedView}
            metricData={data}
            dataInterval={selectedInterval}
            requestedDateRange={dateRangeValue}
            showTotal={showTotal}
            showPercentageChange={showPercentageChange}
          />
        </Grid>
      )
    })
}
